/**
 * The M:SS text of the resend countdown (58 → "0:58", 60 → "1:00"). ResendCode and the login site's
 * "Send a new code in …" label both use it, so every countdown on the page reads the same.
 */
export class CountdownFormat {
    /** Negative values show "0:00"; a fraction of a second rounds up, so "0:00" only shows once the wait is over. */
    static format(secondsLeft) {
        const wholeSecondsLeft = Math.max(0, Math.ceil(secondsLeft));
        const minutes = Math.floor(wholeSecondsLeft / 60);
        const seconds = String(wholeSecondsLeft % 60).padStart(2, '0');
        return `${minutes}:${seconds}`;
    }
}
//# sourceMappingURL=CountdownFormat.js.map